export default __webpack_public_path__ + "static/media/64.681681c3.jpg";